import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageTransactionsComponent from '@app/components/manage-transactions/list';


const ManageTransactions: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Transactions</PageTitle>
      <ManageTransactionsComponent />
    </>
  );
};

export default ManageTransactions;
